{
  "welcome": {
    "title": "Bienvenido a Tworks",
    "subtitle": "Organiza tu trabajo, captura ideas con voz y deja que la IA te ayude a no olvidar nada.",
    "create_account": "Crear cuenta",
    "have_account": "Ya tengo cuenta"
  },
  "tour": {
    "skip": "Saltar",
    "start": "Empezar",
    "next": "Siguiente",
    "slides": {
      "tasks_title": "Tus tareas, simples",
      "tasks_body": "Crea, asigna y completa tareas en segundos.",
      "meetings_title": "Reuniones inteligentes",
      "meetings_body": "Graba y la IA extrae las tareas automáticamente.",
      "team_title": "Trabajo en equipo",
      "team_body": "Comparte proyectos con tu equipo en tiempo real."
    }
  },
  "permissions": {
    "title": "Permisos",
    "notifications_title": "Notificaciones",
    "notifications_subtitle": "Te avisamos cuando te asignen una tarea o comenten en algo tuyo.",
    "mic_title": "Micrófono",
    "mic_subtitle": "Para grabar reuniones y extraer tareas con IA. El audio se procesa en nuestro servidor y se borra a los 90 días.",
    "allow": "Permitir",
    "activated": "✓ Activado",
    "open_settings": "Activar en Settings",
    "continue": "Continuar"
  },
  "oem": {
    "title": "Configuración importante",
    "warning_html": "Tu teléfono <strong>{device}</strong> tiene un optimizador de batería que puede cerrar Tworks mientras grabas reuniones, perdiéndose el audio.",
    "steps_label": "Pasos:",
    "open_settings": "Abrir ajustes de Tworks",
    "skip": "Saltar (puedo perder grabaciones)"
  },
  "force_upgrade": {
    "title": "Actualiza Tworks",
    "subtitle": "Esta versión ya no es compatible. Actualiza desde la tienda para seguir usando la app.",
    "go_to_store": "Ir a la tienda"
  },
  "recovery": {
    "title": "Grabaciones interrumpidas",
    "subtitle_one": "Encontramos {n} grabación sin subir de una sesión anterior.",
    "subtitle_other": "Encontramos {n} grabaciones sin subir de una sesión anterior.",
    "discard": "Descartar",
    "recover": "Recuperar",
    "recover_unavailable": "Recuperación no disponible aún",
    "discard_all": "Descartar todas las grabaciones",
    "toast_recovered": "Grabación recuperada correctamente.",
    "toast_unavailable": "La recuperación automática aún no está disponible. Puedes descartar el archivo.",
    "toast_failed": "No se pudo recuperar la grabación. Intenta de nuevo.",
    "toast_delete_failed": "No se pudo eliminar el archivo. Intenta de nuevo."
  }
}
